/**
 * src/gm/events/live-bus.ts — 瞬时流式增量广播（设计稿 §3.1）。
 *
 * 逐 token 增量不持久化——那是瞬时表现，直接喂打字机；持久层只收
 * 节流后的 stream-snapshot（见 event-log.ts）。关页即散，无恢复义务。
 */

export interface StreamDelta {
  stage: string // 当前干活的人（员工名 / 评审笔名）
  channel: 'content' | 'reasoning'
  text: string // 增量文本
  received: number // 已累计字符数
}

type LiveListener = (d: StreamDelta) => void
const listeners = new Set<LiveListener>()

export function subscribeLive(cb: LiveListener): () => void {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

export function emitLive(d: StreamDelta): void {
  for (const l of listeners) l(d)
}
